import { render } from "./DeleteFileModal.vue?vue&type=template&id=5d7d1286&scoped=true"
import script from "./DeleteFileModal.vue?vue&type=script&lang=js"
export * from "./DeleteFileModal.vue?vue&type=script&lang=js"

import "./DeleteFileModal.vue?vue&type=style&index=0&id=5d7d1286&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d7d1286"]])

export default __exports__